module.exports = __webpack_public_path__ + "static/img/mask-group-3.c6a83ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mask-group-3.png
// module id = 3NWg
// module chunks = 0